import React from "react";
import { Code, LayoutTemplate, Search, Smartphone, Zap, ShoppingCart, Cpu, Globe, Layers } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Medical Billing",
  description: "End-to-end claims submission and payment posting to accelerate your cash flow and reduce administrative overhead.",
  icon: Layers
}, {
  title: "Medical Coding",
  description: "Certified coding experts ensuring precision in ICD-10 and CPT documentation to minimize claim rejections and audits.",
  icon: Code
}, {
  title: "Revenue Cycle Management",
  description: "A holistic financial strategy managing the patient journey from insurance verification to final reimbursement.",
  icon: Zap
}, {
  title: "Credentialing & Enrollment",
  description: "Expert management of provider enrollment and payer credentialing to expand your practice's network reach.",
  icon: Globe
}, {
  title: "Practice Audit & Analytics",
  description: "Data-driven operational audits to identify revenue leakages and optimize your practice’s financial performance.",
  icon: Search
}, {
  title: "Patient Support Services",
  description: "Dedicated billing assistance and query resolution to enhance the patient experience and streamline payments.",
  icon: Smartphone
}];
export default function EngineeredForGrowth() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="28954" id="our-core-specializations" className="bg-background text-foreground relative overflow-hidden py-24 sm:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.03]" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h100v100H0z' fill='none'/%3E%3Cpath d='M10 10c10 20 30 10 40 30s20 40 40 20' stroke='%231a365d' stroke-width='1' fill='none'/%3E%3Cpath d='M0 50c20-10 40 10 60 0s40-20 40 0' stroke='%231a365d' stroke-width='1' fill='none'/%3E%3C/svg%3E")`,
      backgroundSize: '400px 400px'
    }} />
      
      {}
      <div className="pointer-events-none absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-96 bg-primary/10 blur-[120px] rounded-full" />

      <div className="container relative mx-auto px-4 sm:px-6 lg:px-8" ref={ref}>
        <div className={`mb-16 max-w-2xl transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="font-default text-4xl font-bold tracking-tight text-primary sm:text-5xl">
            Our Core <span className="text-secondary">Specializations</span>
          </h2>
          <p className="mt-6 text-lg text-muted-foreground font-sans">
            Ferio Solutions deploys precision-driven financial architectures for healthcare providers. We combine regulatory expertise with technological superiority to optimize your revenue cycle.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {services.map((service, i) => <div key={i} data-index={i} className={`group relative h-full transition-all duration-700 delay-[${i * 100}ms] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
              {}
              <div className="relative h-full overflow-hidden rounded-xl bg-border/50 p-[1px] transition-all duration-300 group-hover:bg-primary/20">
                {}
                <div className="absolute inset-[-100%] animate-[spin_3s_linear_infinite] bg-[conic-gradient(from_90deg_at_50%_50%,transparent_0%,transparent_50%,var(--color-primary)_100%)] opacity-0 transition-opacity duration-300 group-hover:opacity-20" />
                
                {}
                <Card className="relative h-full border-none bg-card/70 backdrop-blur-md shadow-sm transition-colors duration-300 group-hover:bg-primary/5">
                  <CardHeader>
                    <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-lg border border-border bg-background/80 text-primary shadow-sm backdrop-blur-sm transition-transform duration-300 group-hover:-translate-y-1 group-hover:scale-110">
                      <service.icon className="h-6 w-6" strokeWidth={2} />
                    </div>
                    <CardTitle className="font-default text-xl font-bold tracking-wide text-primary">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-base leading-relaxed text-muted-foreground font-sans">
                      {service.description}
                    </CardDescription>
                  </CardContent>
                  
                  {}
                  <div className="absolute top-0 right-0 p-3 opacity-10 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="h-2 w-2 border-t border-r border-primary" />
                  </div>
                  <div className="absolute bottom-0 left-0 p-3 opacity-10 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="h-2 w-2 border-b border-l border-primary" />
                  </div>
                </Card>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}